module.exports = __webpack_public_path__ + "img/follower_white.a3501dc5.svg";